<template>
  <div>
    <div class="cantainer">
      <my-tab1 :title="title"></my-tab1>
      <img :src="bj" alt="" class="cantainer-img">
      <div class="content top">
        <my-NewsNav :title="newsNav.name" :list="newsNav.children" :is-list="true" style="margin-right: 40px"></my-NewsNav>
        <my-NewsItem style="margin-right: 40px"></my-NewsItem>
      </div>

    </div>
    <my-end class="top"></my-end>
  </div>
</template>

<script>
import Tab1 from '@/components/tabs/tabs1'
import NewsNav from '@/components/NewsNav'
import NewsItem from '@/components/NewsItem'
import End from '@/components/End-text'
import dian from '@/assets/bj.png'
import axios from "axios";
import {orgId, requestUrl} from "../common/cons";
export default {
name: "NewsList",
  components:{
    'my-tab1':Tab1,
    'my-end':End,
    'my-NewsNav':NewsNav,
    'my-NewsItem':NewsItem,
  },
  data(){
    return{
      bj:dian,
      title:[],
      newsNav: {},
      columnId: ''
    }
  },

  async mounted () {
    this.columnId = this.$route.params.id
    await this.queryNavList()
  },
  methods:{
    async queryNavList(){
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      const columns = await axios.get(`${requestUrl}/news/getChannelList?id=${this.columnId}`)
      this.title=result.data
      this.newsNav = columns.data[0]
    }
  }
}
</script>

<style scoped>
.cantainer{
  width: 100%;
  display: flex;
  flex-direction: column;
}
.top{
  margin-top: 20px;
}
.right{
  margin-right: 50px;
}
.cantainer-img{
  width: 100%;
  height: 180px;
  margin-top: 20px;
}
.content{
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/page/NewsList.vue